<template>
<!-- 查看版本 -->
  <el-dialog
    :title="$t('button.look')+$t('button.examine')"
    :visible.sync="lookUpVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <div class="versions-status">
        <div class="versions-flex">
          <span v-if="lookUpData.status == 0">{{$t('pages.system.text7')}}</span>
          <span v-if="lookUpData.status == 1"> {{$t('pages.system.text8')}}</span>
          <span v-if="lookUpData.status == 2" style="color:#D9001B"> {{$t('pages.system.text9')}}</span>
          
          <span v-if="lookUpData.status != 0">{{lookUpData.reviewerId}}</span>
          <span v-if="lookUpData.status != 0">{{lookUpData.reviewPassTime}}</span>
        </div>
        <div class="tips" v-if="lookUpData.status == 1">{{lookUpData.annotation}}</div>
        <div class="tips" v-if="lookUpData.status == 2">{{lookUpData.annotation}}</div>
      </div>
      <div class="versions-content">
        <div class="versions-content-flex">
          <div class="versions-content-flex-title">{{$t('pages.system.text14')}}</div>
          <div class="versions-content-flex-content">{{lookUpData.version}}</div>
        </div>
        <div class="versions-content-flex">
          <div class="versions-content-flex-title">{{$t('pages.system.text15')}}</div>
          <div class="versions-content-flex-content">{{lookUpData.intro}}</div>
        </div>
        <div class="versions-content-flex">
          <div class="versions-content-flex-title">{{$t('pages.system.text16')}}</div>
          <div class="versions-content-flex-content">
            <a :href="lookUpData.filePath" :download="lookUpData.fileName">{{lookUpData.fileName}}</a>
            <span>{{ sizeReset(lookUpData.fileSize)}}</span>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('button.cancel')}}</el-button>
      <el-button type="primary" @click="handleClose">{{$t('button.determine')}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { sizeReset } from '../../../../utils/util/validate'
export default {
  data() {
    return {};
  },
  props: ["lookUpVisible", "lookUpData"],
  methods: {
    handleClose() {
      this.$emit("lookUpClose");
    },
    sizeReset(size){
       return sizeReset(size)
    }
  },
};
</script>

<style scoped>
.from-body {
  display: flex;
  flex-direction: column;
}
.versions-status {
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  background-color: #f4f6f9;
  margin-bottom: 10px;
}
.versions-flex {
  display: flex;
  align-items: center;
}
.versions-flex span {
  margin-right: 40px;
}
.tips{
    margin-top: 10px;
}
.versions-content {
  padding: 10px 20px;
  box-sizing: border-box;
}
.versions-content-flex {
  display: flex;
  margin-bottom: 14px;
}
.versions-content-flex-title {
  margin-right: 40px;
  width: 80px;
  text-align: end;
  flex-shrink: 0;
}
.versions-content-flex-content {
  display: flex;
}
.versions-content-flex-content a {
  margin-right: 20px;
}
</style>